import App from 'containers/App';
import CustomUIProvider from './CustomUIProvider';
import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import ReactDOM from 'react-dom';
import { ScrollToTop } from 'components';
import * as serviceWorker from './serviceWorker';
// this import is required in order to augment emotion builtin Theme interface
import 'mymoria-ui/styles/theme';

ReactDOM.render(
  <Router>
    <CustomUIProvider>
      <ScrollToTop>
        <App />
      </ScrollToTop>
    </CustomUIProvider>
  </Router>,
  document.getElementById('root'),
);

serviceWorker.unregister();
